import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CheckIn } from '../components/connects/connects';
import { Church } from '../components/church-list/church';

@Injectable({
  providedIn: 'root'
})
export class ConnectsService {

  constructor(private readonly http:HttpClient) { }


  getConnects(){
    return this.http.get('/api/connects');
  }
  getConnectsWithSearch(name:string,page:number,size:number){
    return this.http.get(`/api/search?name=${name}&page=${page}&size=${size}`);
  }

  getChurches(){
    return this.http.get('/api/church/all');
  }
  checkIn(id:number,checkIn:CheckIn){
    checkIn.connectStatus=true;
    return this.http.post(`/api/checkin/${id}`,checkIn);
  }

  getLocals(){
    return this.http.get('/api/locals');
  }

  
  deleteChurch(id:number){
    //Observe response to get status code
    return this.http.delete(`/api/church/${id}`,{observe:'response'});
  }
  addChurch(church:Church){
    return this.http.post('/api/church',church);
  }
  updateChurch(church:Church){
    return this.http.put('/api/church',church,{observe:'response'});
  }
}
